import { api, qs } from "./base";
import type { CoverageFilter, FindingsResponse } from "@/common/types";

/**
 * A repo's findings, already grouped server-side into one entry per distinct CVE, plus the
 * REQ-centric view. `image` narrows to one image (ECR repo / Lambda name); omit for all
 * images, deduped by CVE. `coverage` picks which CVEs come back (default on the server:
 * "needs-action" - those without a valid exception).
 */
export function listFindings(params: {
  repo: string;
  image?: string;
  coverage?: CoverageFilter;
}): Promise<FindingsResponse> {
  return api.get<FindingsResponse>(`/findings${qs(params)}`);
}
